const Values = {
  FiliacaoStatusValues: {
    ativo: '846c7bc8-2487-4df3-8d8e-7555a7c971f6',
    inativo: '8ee4bba5-d6bd-4c97-aa74-35f1a6e581c7',
    pendente: 'f2afa527-d765-4bfe-aa2a-3fb9f05b7547',
    inadimplente: '612fcaec-478d-4112-98e8-09bbb99158ac'
  },
  MessageValues: {
    erro_catch: 'Ocorreu um erro no processamento da requisição. Contate o suporte.',
  },
  Modalidades: {
    trapAmericano: '18297539-d2e8-4676-bd21-f8a36bfb565a',
    tiroIndoor: 'aa54872d-69f8-46df-b025-f2f202c250fe',
    tiroAberto: '38ee1fcd-e9df-47ba-8d7e-f098509a6f12',
    tiroArComprimido: 'a0f99c59-6342-40c5-8fec-00a80bbcdb08'
  },
  quantidadeTirosRodadaTrap: 25,
  limiteRegistroLista: 20,
  cores: {
    branco: '#FFFFFF',
    corPrimaria: '#295138',
    cinza: '#F4F6F8',
    preto: '#000000'
  },
  versao: {
    descricao: '4.7.1',
    dataUltimaAtualizacao: '03/12/2020'
  },
  meses: ['Janeiro', 'Fevereiro', 'Marco', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
  estoqueInsumoMovimentacao: {
    tipoMovimentacao: {
      positiva: 'P',
      negativa: 'N'
    }
  },

};

export {Values}
